// Module-level store for a Balance Import's external key sets (same pattern as validationResultStore):
// tens of thousands of strings that don't belong in redux. Lost on refresh; reloaded by loadExternalKeySets.

import { ExternalKeySet } from "../engine/validationTypes";

export type ExternalKeySetData = {
  parentSubmissionID: string;
  parentReferenceNo?: string;
  keySets: Record<string, ExternalKeySet>;
  missingWorksheets: string[];
};

const keySetsBySubmission = new Map<string, ExternalKeySetData>();

export function setExternalKeySets(submissionID: string, data: ExternalKeySetData): void {
  keySetsBySubmission.set(submissionID, data);
}

export function getExternalKeySets(submissionID: string): ExternalKeySetData | undefined {
  return keySetsBySubmission.get(submissionID);
}
